"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Generated API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoftwareUpdatesApi = exports.SoftwareUpdatesApiFactory = exports.SoftwareUpdatesApiFp = exports.SoftwareUpdatesApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * SoftwareUpdatesApi - axios parameter creator
 * @export
 */
const SoftwareUpdatesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {AppInfo} [appInfo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        softwareUpdateResourceCreateApp: (appInfo_1, ...args_1) => __awaiter(this, [appInfo_1, ...args_1], void 0, function* (appInfo, options = {}) {
            const localVarPath = `/applications/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(appInfo, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} app
         * @param {string} stream
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        softwareUpdateResourceDeleteUpdate: (app_1, stream_1, version_1, ...args_2) => __awaiter(this, [app_1, stream_1, version_1, ...args_2], void 0, function* (app, stream, version, options = {}) {
            // verify required parameter 'app' is not null or undefined
            (0, common_1.assertParamExists)('softwareUpdateResourceDeleteUpdate', 'app', app);
            // verify required parameter 'stream' is not null or undefined
            (0, common_1.assertParamExists)('softwareUpdateResourceDeleteUpdate', 'stream', stream);
            // verify required parameter 'version' is not null or undefined
            (0, common_1.assertParamExists)('softwareUpdateResourceDeleteUpdate', 'version', version);
            const localVarPath = `/applications/delete/{app}/{stream}/{version}`
                .replace(`{${"app"}}`, encodeURIComponent(String(app)))
                .replace(`{${"stream"}}`, encodeURIComponent(String(stream)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} app
         * @param {string} stream
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        softwareUpdateResourceDownload: (app_2, stream_2, version_2, ...args_3) => __awaiter(this, [app_2, stream_2, version_2, ...args_3], void 0, function* (app, stream, version, options = {}) {
            // verify required parameter 'app' is not null or undefined
            (0, common_1.assertParamExists)('softwareUpdateResourceDownload', 'app', app);
            // verify required parameter 'stream' is not null or undefined
            (0, common_1.assertParamExists)('softwareUpdateResourceDownload', 'stream', stream);
            // verify required parameter 'version' is not null or undefined
            (0, common_1.assertParamExists)('softwareUpdateResourceDownload', 'version', version);
            const localVarPath = `/applications/download/{app}/{stream}/{version}`
                .replace(`{${"app"}}`, encodeURIComponent(String(app)))
                .replace(`{${"stream"}}`, encodeURIComponent(String(stream)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} app
         * @param {string} stream
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        softwareUpdateResourceGetLatestVersion: (app_3, stream_3, ...args_4) => __awaiter(this, [app_3, stream_3, ...args_4], void 0, function* (app, stream, options = {}) {
            // verify required parameter 'app' is not null or undefined
            (0, common_1.assertParamExists)('softwareUpdateResourceGetLatestVersion', 'app', app);
            // verify required parameter 'stream' is not null or undefined
            (0, common_1.assertParamExists)('softwareUpdateResourceGetLatestVersion', 'stream', stream);
            const localVarPath = `/applications/version/{app}/{stream}`
                .replace(`{${"app"}}`, encodeURIComponent(String(app)))
                .replace(`{${"stream"}}`, encodeURIComponent(String(stream)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} app
         * @param {string} stream
         * @param {string} [from]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        softwareUpdateResourceGetUpdateInfo: (app_4, stream_4, from_1, to_1, ...args_5) => __awaiter(this, [app_4, stream_4, from_1, to_1, ...args_5], void 0, function* (app, stream, from, to, options = {}) {
            // verify required parameter 'app' is not null or undefined
            (0, common_1.assertParamExists)('softwareUpdateResourceGetUpdateInfo', 'app', app);
            // verify required parameter 'stream' is not null or undefined
            (0, common_1.assertParamExists)('softwareUpdateResourceGetUpdateInfo', 'stream', stream);
            const localVarPath = `/applications/updateInfo/{app}/{stream}`
                .replace(`{${"app"}}`, encodeURIComponent(String(app)))
                .replace(`{${"stream"}}`, encodeURIComponent(String(stream)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {AppInfo} [appInfo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        softwareUpdateResourceUpdateApp: (appInfo_2, ...args_6) => __awaiter(this, [appInfo_2, ...args_6], void 0, function* (appInfo, options = {}) {
            const localVarPath = `/applications/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(appInfo, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} app
         * @param {string} stream
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        softwareUpdateResourceUploadVersion: (app_5, stream_5, ...args_7) => __awaiter(this, [app_5, stream_5, ...args_7], void 0, function* (app, stream, options = {}) {
            // verify required parameter 'app' is not null or undefined
            (0, common_1.assertParamExists)('softwareUpdateResourceUploadVersion', 'app', app);
            // verify required parameter 'stream' is not null or undefined
            (0, common_1.assertParamExists)('softwareUpdateResourceUploadVersion', 'stream', stream);
            const localVarPath = `/applications/upload/{app}/{stream}`
                .replace(`{${"app"}}`, encodeURIComponent(String(app)))
                .replace(`{${"stream"}}`, encodeURIComponent(String(stream)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.SoftwareUpdatesApiAxiosParamCreator = SoftwareUpdatesApiAxiosParamCreator;
/**
 * SoftwareUpdatesApi - functional programming interface
 * @export
 */
const SoftwareUpdatesApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.SoftwareUpdatesApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {AppInfo} [appInfo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        softwareUpdateResourceCreateApp(appInfo, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.softwareUpdateResourceCreateApp(appInfo, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SoftwareUpdatesApi.softwareUpdateResourceCreateApp']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} app
         * @param {string} stream
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        softwareUpdateResourceDeleteUpdate(app, stream, version, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.softwareUpdateResourceDeleteUpdate(app, stream, version, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SoftwareUpdatesApi.softwareUpdateResourceDeleteUpdate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} app
         * @param {string} stream
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        softwareUpdateResourceDownload(app, stream, version, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.softwareUpdateResourceDownload(app, stream, version, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SoftwareUpdatesApi.softwareUpdateResourceDownload']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} app
         * @param {string} stream
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        softwareUpdateResourceGetLatestVersion(app, stream, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.softwareUpdateResourceGetLatestVersion(app, stream, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SoftwareUpdatesApi.softwareUpdateResourceGetLatestVersion']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} app
         * @param {string} stream
         * @param {string} [from]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        softwareUpdateResourceGetUpdateInfo(app, stream, from, to, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.softwareUpdateResourceGetUpdateInfo(app, stream, from, to, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SoftwareUpdatesApi.softwareUpdateResourceGetUpdateInfo']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {AppInfo} [appInfo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        softwareUpdateResourceUpdateApp(appInfo, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.softwareUpdateResourceUpdateApp(appInfo, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SoftwareUpdatesApi.softwareUpdateResourceUpdateApp']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} app
         * @param {string} stream
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        softwareUpdateResourceUploadVersion(app, stream, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.softwareUpdateResourceUploadVersion(app, stream, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SoftwareUpdatesApi.softwareUpdateResourceUploadVersion']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.SoftwareUpdatesApiFp = SoftwareUpdatesApiFp;
/**
 * SoftwareUpdatesApi - factory interface
 * @export
 */
const SoftwareUpdatesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.SoftwareUpdatesApiFp)(configuration);
    return {
        /**
         *
         * @param {SoftwareUpdatesApiSoftwareUpdateResourceCreateAppRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        softwareUpdateResourceCreateApp(requestParameters = {}, options) {
            return localVarFp.softwareUpdateResourceCreateApp(requestParameters.appInfo, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SoftwareUpdatesApiSoftwareUpdateResourceDeleteUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        softwareUpdateResourceDeleteUpdate(requestParameters, options) {
            return localVarFp.softwareUpdateResourceDeleteUpdate(requestParameters.app, requestParameters.stream, requestParameters.version, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SoftwareUpdatesApiSoftwareUpdateResourceDownloadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        softwareUpdateResourceDownload(requestParameters, options) {
            return localVarFp.softwareUpdateResourceDownload(requestParameters.app, requestParameters.stream, requestParameters.version, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SoftwareUpdatesApiSoftwareUpdateResourceGetLatestVersionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        softwareUpdateResourceGetLatestVersion(requestParameters, options) {
            return localVarFp.softwareUpdateResourceGetLatestVersion(requestParameters.app, requestParameters.stream, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SoftwareUpdatesApiSoftwareUpdateResourceGetUpdateInfoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        softwareUpdateResourceGetUpdateInfo(requestParameters, options) {
            return localVarFp.softwareUpdateResourceGetUpdateInfo(requestParameters.app, requestParameters.stream, requestParameters.from, requestParameters.to, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SoftwareUpdatesApiSoftwareUpdateResourceUpdateAppRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        softwareUpdateResourceUpdateApp(requestParameters = {}, options) {
            return localVarFp.softwareUpdateResourceUpdateApp(requestParameters.appInfo, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SoftwareUpdatesApiSoftwareUpdateResourceUploadVersionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        softwareUpdateResourceUploadVersion(requestParameters, options) {
            return localVarFp.softwareUpdateResourceUploadVersion(requestParameters.app, requestParameters.stream, options).then((request) => request(axios, basePath));
        },
    };
};
exports.SoftwareUpdatesApiFactory = SoftwareUpdatesApiFactory;
/**
 * SoftwareUpdatesApi - object-oriented interface
 * @export
 * @class SoftwareUpdatesApi
 * @extends {BaseAPI}
 */
class SoftwareUpdatesApi extends base_1.BaseAPI {
    /**
     *
     * @param {SoftwareUpdatesApiSoftwareUpdateResourceCreateAppRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoftwareUpdatesApi
     */
    softwareUpdateResourceCreateApp(requestParameters = {}, options) {
        return (0, exports.SoftwareUpdatesApiFp)(this.configuration).softwareUpdateResourceCreateApp(requestParameters.appInfo, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SoftwareUpdatesApiSoftwareUpdateResourceDeleteUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoftwareUpdatesApi
     */
    softwareUpdateResourceDeleteUpdate(requestParameters, options) {
        return (0, exports.SoftwareUpdatesApiFp)(this.configuration).softwareUpdateResourceDeleteUpdate(requestParameters.app, requestParameters.stream, requestParameters.version, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SoftwareUpdatesApiSoftwareUpdateResourceDownloadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoftwareUpdatesApi
     */
    softwareUpdateResourceDownload(requestParameters, options) {
        return (0, exports.SoftwareUpdatesApiFp)(this.configuration).softwareUpdateResourceDownload(requestParameters.app, requestParameters.stream, requestParameters.version, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SoftwareUpdatesApiSoftwareUpdateResourceGetLatestVersionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoftwareUpdatesApi
     */
    softwareUpdateResourceGetLatestVersion(requestParameters, options) {
        return (0, exports.SoftwareUpdatesApiFp)(this.configuration).softwareUpdateResourceGetLatestVersion(requestParameters.app, requestParameters.stream, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SoftwareUpdatesApiSoftwareUpdateResourceGetUpdateInfoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoftwareUpdatesApi
     */
    softwareUpdateResourceGetUpdateInfo(requestParameters, options) {
        return (0, exports.SoftwareUpdatesApiFp)(this.configuration).softwareUpdateResourceGetUpdateInfo(requestParameters.app, requestParameters.stream, requestParameters.from, requestParameters.to, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SoftwareUpdatesApiSoftwareUpdateResourceUpdateAppRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoftwareUpdatesApi
     */
    softwareUpdateResourceUpdateApp(requestParameters = {}, options) {
        return (0, exports.SoftwareUpdatesApiFp)(this.configuration).softwareUpdateResourceUpdateApp(requestParameters.appInfo, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SoftwareUpdatesApiSoftwareUpdateResourceUploadVersionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoftwareUpdatesApi
     */
    softwareUpdateResourceUploadVersion(requestParameters, options) {
        return (0, exports.SoftwareUpdatesApiFp)(this.configuration).softwareUpdateResourceUploadVersion(requestParameters.app, requestParameters.stream, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.SoftwareUpdatesApi = SoftwareUpdatesApi;
//# sourceMappingURL=software-updates-api.js.map